import TopicOne from "../../../components/platform-contents/pips-terminal-contents/TopicOne";

const PipsTradeAppContentFive = () => {
  return (
    <>
      <TopicOne />

      <div className="how__work__platform">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="thumb-left">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/platforms/pips_terminal/pips_terminal_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="content-right">
                <h2>The Future of Trading, Simplified</h2>
                <p>
                  The Pips Terminal is our proprietary multi-asset platform that
                  unites performance, analytics, and usability in one powerful
                  environment. Whether you trade Forex, Crypto, or Stocks, the
                  terminal provides advanced charting, integrated analysis
                  tools, and real-time market execution, all tailored for
                  beginners and professionals alike. Every feature is engineered
                  to help you trade smarter, faster, and more confidently. Built
                  with institutional-grade technology, it empowers you to react
                  instantly to market shifts with unmatched stability.
                  Customizable layouts and intuitive controls ensure that your
                  workflow adapts to your strategy—not the other way around.
                  With seamless syncing across devices, you can monitor, manage,
                  and optimize your trades anytime, anywhere.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PipsTradeAppContentFive;
